<div class="datablock">
  <div class="inputgroup">
    <label>{{'Odometer value'|translate}}</label>
    <label>
      <input [readOnly]="!canEditTrackers" type="number" step="any" placeholder="0.00" [(ngModel)]="mileage"
      />
      <span>{{'km'|localizeUnits}}</span>
    </label>
    <button [disabled]="!canEditTrackers" class="btn_blue" (click)="syncDistance()">{{'Sync'|translate}}</button>
  </div>
  <div class="inputgroup">
    <label>{{'Working time'|translate}}</label>
    <label>
      <input [readOnly]="!canEditTrackers"  type="number" step="any" placeholder="0" [(ngModel)]="engineTime"/>
      <span>{{'hours'|translate}}</span>
    </label>
    <button [disabled]="!canEditTrackers" class="btn_blue"  (click)="syncEngineTime()">{{'Sync'|translate}}</button>
  </div>
  <div class="addinfo">* {{'For synchronization one must use morning data'|translate}}</div>
</div>
